/**
 * @description Common Store Module
 * @author Fahid Mohammad
 */
import Vue from 'vue';
import http from '../../util/axios';
import i18n from '../../i18n';
import config from '../../config';
import router from '../../router';
import { getPermissionNotificationType } from "../../constants/permission-notification";    

export default {
    namespaced: true,
    state: {
        showNotification: false,
        notificationPayload: null,
        locale: i18n.locale,
        country: 'SA',
        location:{},
        defaultLocation:{
            address: 'Riyadh Saudi Arabia',
            latitude: "24.7135517",
            longitude: "46.6752957"
        },
        showWelcome:false,
        showInsurancePopup:false,
        permissions : {
            location: false,
            notification: false,
            camera: false,
            audio: false
        },
		alertMessage: {
			msg: '',
			class: ''
		},
        showPermissionNotification: false,
        permissionNotificationPayload: null,
    },
    mutations: {
        SET_LOCALE: (state, locale) => {
            state.locale = locale
        },
        SET_LOCATION: (state, payload) => {
            state.location = payload
        },
        SET_DEFAULT_LOCATION: (state) => {
            state.location = state.defaultLocation;
        },
        SET_PERMISSION: (state, payload) => {
            state.permissions[payload.key] = payload.value
        },
        SET_ALERTMESSAGE: (state, payload) => {
            state.alertMessage = payload
        },
        SHOW_NOTIFICATION: (state, payload) => {
            state.showNotification = payload
        },
        SET_NOTIFICATION_PAYLOAD:(state, payload) => {
            state.notificationPayload = payload
        },
        SET_WELCOME: (state, payload) => {
            state.showWelcome = payload
        },
        SET_INSURANCE_POPUP: (state, payload) => {
            state.showInsurancePopup = payload
        },
        SHOW_PERMISSION_NOTIFICATION: (state, payload) => {
            state.showPermissionNotification = payload
        },
        SET_PERMISSION_NOTIFICATION_PAYLOAD:(state, payload) => {
            state.permissionNotificationPayload = payload
        },
    },
    actions: {
        SHOW_NOTIFICATION({ commit }, payload) {
            commit('SHOW_NOTIFICATION', payload);
        },
        SET_NOTIFICATION_PAYLOAD({ commit }, payload) {
            commit('SET_NOTIFICATION_PAYLOAD', payload)
        },
        SHOW_PERMISSION_NOTIFICATION: ({ commit }, payload) => {
            commit('SHOW_PERMISSION_NOTIFICATION', payload);
        },
        SET_PERMISSION_NOTIFICATION_PAYLOAD:({ commit }, type) => {
            commit('SET_PERMISSION_NOTIFICATION_PAYLOAD', getPermissionNotificationType(type));
        },
        ON_NOTIFICATION_CLICK({ commit, getters }) {
            const { id, type, utid } = getters.getNotificationPayload.data

            switch (type) {
                case 'chat':
                    if(utid && (utid==='3' || utid==='4')){
                        router.push({
                            name: 'tracking-chat',
                            params: { chatroom: id,utid:utid },
                        }); 
                    }else {
                        router.push({
                            name: 'chat',
                            params: { chatroom: id },
                        });
                    }
                           
                    break;
                case 'appointment':
                    // handle appointment redirection
                    break;
                default:
                    break;
            }
        },
        CHANGE_LANGUAGE({ commit }, lang) {
            if (lang) {
                i18n.locale = lang
            } else {
                i18n.locale = ((i18n.locale == 'en') ? 'ar' : 'en')
            }
            Vue.localStorage.set('lang', i18n.locale)
            commit('SET_LOCALE', i18n.locale)
            //todo make API call to update user settings
        },
        async GET_PLACE_NAME({commit, dispatch},{latitude, longitude}){
            let response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyC2TizoJSheddmV6agssbg4pvuW9aXlIyo`)
            let data =  await response.json()
            let location = {
                latitude:latitude.toString(),
                longitude:longitude.toString(),
                address:data.results[0].formatted_address
            }
            // commit('SET_LOCATION', location)
            dispatch('SET_LOCATION', location)
            dispatch('SET_PERMISSION', {key:'location', value: true})
            return;
        },
        SET_LOCATION( { commit } , payload) {
            commit('SET_LOCATION', payload)
        },
        SET_DEFAULT_LOCATION( { commit } ) {
            commit('SET_DEFAULT_LOCATION')
        },
        SET_PERMISSION( { commit } , payload) {
            commit('SET_PERMISSION', payload);
        },
        SET_ALERTMESSAGE( { commit } , payload) {
            commit('SET_ALERTMESSAGE', payload);
        },
        FCM_TOKEN_UPDATE( { commit }, payload) {
            return new Promise(( resolve, reject ) => {
                return http.post( `${config.COMM_ENDPOINT}/fcm/save`, payload )
                    .then(res => {
                        if( res.status===1000 ) {
                            resolve({ message: res.message || '' })
                        } else {
                            reject({ message: res.message || '' })
                        }
                    })
            })
        },
        SET_WELCOME( { commit }, payload) {
            commit('SET_WELCOME', payload)
        },
    },
    getters: {
        getLocale: state => { return state.locale },       
        getLocationValues: state => { return state.location },
        getChatExtraTime: state => state.staticData.chat_extratime,
        isLocationEnabled: state => state.permissions.location,
        getAlertMessage: state => state.alertMessage,
        getNotificationStatus: state => state.showNotification,
        getNotificationPayload: state => state.notificationPayload,
        getWelcomeStatus: state => state.showWelcome,
        getDefaultLocation: state => state.defaultLocation,
        getPermissionNotificationStatus: state => state.showPermissionNotification,
        getPermissionNotificationPayload: state => state.permissionNotificationPayload
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/common.js